import { buildRoute } from '@direct-frontend/modules-router';

/**
 * Раздел настроек меню
 */
export const menuRoute = buildRoute('/menu');
